import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mainButton: {
    borderRadius: '0.3rem',
    textTransform: 'none',
    borderColor: theme.palette.gray.efesBorder,
    height: 46,
    '&:active': {
      backgroundColor: theme.palette.primary.pressed,
      color: theme.palette.white.main,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.pressed,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.pressed,
      color: theme.palette.white.main,
    },
  },
}));

export default useStyles;
